export default __webpack_public_path__ + "static/media/open-positions-full-HD.6c7887be.jpg";